import { render } from "./NavTools.vue?vue&type=template&id=b4c00974"
import script from "./NavTools.vue?vue&type=script&lang=js"
export * from "./NavTools.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__